import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { NarrowedEntityData } from '@adornis/bh-util/selectionset-types.js';
import type { TimeSlot } from '../datetime/time-slot.js';
import { readEntitiesByIDs } from '../server/entity-reads.js';
import { Participation } from './Participation.js';
import { Workshop } from './workshop.js';

@Entity()
export class AppointmentParticipation extends AdornisEntity {
  static override _class = 'AppointmentParticipation';

  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(type => Date, { default: v => v ?? new Date() })
  date!: Date;

  @Field(type => String)
  appointmentID!: string;
}

@Entity()
export class ParticipationWorkshop extends Participation<Workshop> {
  static override _class = 'ParticipationWorkshop' as const;

  @Field(type => [AppointmentParticipation], { default: v => v ?? [] })
  appointmentParticipations: Maybe<AppointmentParticipation[]>;

  public override async timespan() {
    const fields = {
      appointments: {
        _id: 1,
        start: 1,
        end: 1,
        isNonBlocking: 1,
        name: 1,
        location: 1,
        meetingLink: { link: 1, ownerID: 1 },
      },
    } as const;
    const [product] = await readEntitiesByIDs<typeof Workshop, typeof fields>(Workshop, [this.productID], fields);

    if (!product) throw new Error('product is missing: ' + this.productID);
    // if (!(product instanceof Workshop)) throw new Error('invalid product instance');

    return product.appointments as NarrowedEntityData<TimeSlot, { _id: 1; start: 1; end: 1; isNonBlocking: 1 }>[];
  }
}
